import { createBeanDecorator } from 'zova';
export function Api() {
  return createBeanDecorator('api', 'app');
}
export function ApiMeta() {
  return createBeanDecorator('apiMeta', 'app');
}
export function ApiSchema() {
  return createBeanDecorator('apiSchema', 'app');
}